/**
 * Key for localStorage location of stateData for step 02.
 * @type {string} "state-02"
 */
export const LS_STATE_02_KEY = "state-02";